import { Component, OnInit } from '@angular/core';
import {CountryModel} from '../../../models/localization-and-pricing/country.model';
import {Router} from '@angular/router';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-evo-land-choose-country',
  templateUrl: './evo-land-choose-country.component.html',
  styleUrls: ['./evo-land-choose-country.component.css']
})
export class EvoLandChooseCountryComponent implements OnInit {

  list = CountryModel.dropdownList();

  /**
   * Currently we have four regions
   * na = north america
   * eu = europe
   * la = latin america (also includes central)
   * as = asia (only India for now)
   */
  regions = ['la', 'as', 'eu', 'na'];

  showRegion = {};

  serverRegion: string;

  constructor(private router: Router,
              private tSv: TranslateService,
              private titleSv: Title) {

    this.serverRegion = this.getRegion();

    // Show countries from current regions first
    const regionIndex = this.regions.indexOf(this.serverRegion);
    this.regions.splice(regionIndex, 1);
    this.regions.splice(0, 0, this.serverRegion);

    // By default, all regions closed
    for (const region of this.regions) {
      this.showRegion[region] = false;
    }

    this.showRegion[this.serverRegion] = true;

  }

  ngOnInit() {

    const country = CountryModel.getHomepageCountry();
    if (country && CountryModel.countriesForCurrentDomain().includes(country)) {

      if (!CultureModel.getHomepageCulture()) {
        CultureModel.setHomepageCulture(CountryModel.cultureForCountry(CountryModel.getHomepageCountry()));
      }

      const culture = CultureModel.getHomepageCulture();

      const paths = NavigationModel.getHomeURLPaths(['landing']);

      // Redirect correctly
      CountryModel.onCountryOrCultureRedirection(this.router, paths, country, culture, this.tSv);

    }

  }

  getRegion(): string {

    const hostName = window.location.hostname;
    if (hostName.includes('la.')) {
      return 'la';
    } else if (hostName.includes('us.')) {
      return 'na';
    } else if (hostName.includes('www.')) {
      return 'eu';
    } else if (hostName.includes('in')) {
      return 'as';
    }

    return 'eu';

  }

  onCountrySelected(country: string) {

    const culture = CountryModel.cultureForCountry(country);
    const paths = ['home', country, culture, 'landing'];

    CountryModel.onCountryOrCultureRedirection(this.router, paths, country, culture, this.tSv);

  }

  /**
   * Todo: Needs translation
   * @param region The name of the server region
   */
  getRegionName(region: string) {

    if (region === 'na') {
      return 'North America';
    } else if (region === 'la') {
      return 'Central and South America';
    } else if (region === 'as') {
      return 'Asia';
    }

    return 'Europe';

  }

  getCountriesForRegion(region: string): string[] {

    if (region === 'la') {
      return CountryModel.LACountriesPublic();
    } else if (region === 'na') {
      return CountryModel.NACountriesPublic();
    } else if (region === 'as') {
      return CountryModel.INCountriesPublic();
    }

    return CountryModel.EUCountriesPublic();

  }

  getCountryTitle(country: string): string {

    return CountryModel.title(country);

  }

  getCountryFlag(country: string): string {

    return CountryModel.iconURL(country);

  }

}
